// @flow
import { takeEvery, put, call } from 'redux-saga/effects';
import { mainApiUrl } from '@lib';
import { pageReady } from '@redux/components/Page/actions';
import {
  CAMPAIGN_REQUEST,
  CAMPAIGN_UPDATE,
} from './constant';
import {
  updateCampaign,
  errorCampaign,
} from './actions';
import type { Action } from '../types';


export function* campaignsRequestFlow({ url }: Action): Generator<Function, void, void> {
  if (!url) return;
  try {
    const apiUrl = `${mainApiUrl}/v1/campaigns/check?url=${encodeURIComponent(url)}`;
    const response = yield call(fetch, apiUrl);
    const data = yield call([response, 'json']);
    if (data) {
      yield put(updateCampaign(data));
    }
  } catch (error) {
    yield put(errorCampaign(error instanceof Error ? error : new Error('Request Error')));
  }
}

export function* campaignsUpdateFlow(action: Action): Generator<Function, void, void> {
  if (action.data) {
    yield put(pageReady());
  }
}

export function* campaignsFlow(action: Action): Generator<Function, void, void> {
  switch (action.type) {
    case CAMPAIGN_REQUEST:
      yield call(campaignsRequestFlow, action);
      break;
    case CAMPAIGN_UPDATE:
      yield call(campaignsUpdateFlow, action);
      break;
    default:
      break;
  }
}
export default function* campaignSaga(): Generator<Function, void, Action> {
  yield takeEvery([CAMPAIGN_REQUEST, CAMPAIGN_UPDATE], campaignsFlow);
}
